import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export function WizardFooter({ children }: { children: ReactNode }) {
  const [el, setEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setEl(document.getElementById('wizard-footer-portal'));
  }, []);

  if (!el) return null;
  return createPortal(children, el);
}
